import React from "react";

import { StyledIconWrapper, StyledImg } from "./styled";

import EmojiLaugh from "img/EmojiLaugh.png";
import FaceGrinBeamSweat from "img/FaceGrinBeamSweat.png";
import FaceGrinSquintTears from "img/FaceGrinSquintTears.png";
import FaceTired from "img/FaceTired.png";
import Favorite from "img/Favorite.png";
import Like from "img/Like.png";
import HandsClapping from "img/HandsClapping.png";

const iconNameList = [
  "EmojiLaugh",
  "FaceGrinBeamSweat",
  "FaceGrinSquintTears",
  "FaceTired",
  "Favorite",
  "Like",
  "HandsClapping",
] as const;

export type IconName = (typeof iconNameList)[number];

export const iconJpNameList: { [enName in IconName]: string } = {
  EmojiLaugh: "スマイル",
  FaceGrinBeamSweat: "苦笑い",
  FaceGrinSquintTears: "ウケる",
  FaceTired: "うわーん",
  Favorite: "ハート",
  Like: "いいね",
  HandsClapping: "拍手",
};

type IconProps = {
  iconName: IconName;
  width?: string;
  onClick?: (iconName: IconName) => void;
};

export const Icon: React.FC<IconProps> = (props) => {
  const { iconName, width, onClick } = props;
  const switchReactionIcon = () => {
    switch (iconName) {
      case "EmojiLaugh":
        return EmojiLaugh;
      case "FaceGrinBeamSweat":
        return FaceGrinBeamSweat;
      case "FaceGrinSquintTears":
        return FaceGrinSquintTears;
      case "FaceTired":
        return FaceTired;
      case "Favorite":
        return Favorite;
      case "Like":
        return Like;
      case "HandsClapping":
        return HandsClapping;
      default:
        return;
    }
  };
  return onClick ? (
    <StyledIconWrapper width={width} onClick={() => onClick(iconName)}>
      {switchReactionIcon()}
    </StyledIconWrapper>
  ) : (
    <StyledIconWrapper width={width}>
      <StyledImg src={switchReactionIcon()} imgWidth={width} />
    </StyledIconWrapper>
  );
};
